<div mat-dialog-container>
  <div class="close-row">
    <a (click)="close()">
      <img
        class="close-icon"
        src="assets/images/shared/Icon - Close - Active.svg"
      />
    </a>
  </div>
  <div mat-dialog-content>
    <div class="body-modal">
      <div class="message-prompt-modal-img">
        <img src="assets/images/shared/Illustration - Helpdesk.svg" />
      </div>

      <div class="modal-title-font title">
        <span class="lbl"> {{ error }}</span>
      </div>

      <div class="modal-text-font">
        <span class="lbl"
          >If you need any assistance, please call us at
          <a href="tel:+60322641006">
            <b class="bolded fw-semi-bold">+603 2264 1006</b>
          </a>
          or email us at
          <a href="mailto:alpha.helpdesk@allianz.com.my">
            <b class="bolded fw-semi-bold">alpha.helpdesk&#64;allianz.com.my</b>
          </a>
        </span>
      </div>
    </div>
  </div>
</div>
